export { ForgotPasswordPage } from "./ForgotPasswordPage"
export type { ForgotPasswordPageProps } from "./ForgotPasswordPage"
